module.exports = __webpack_public_path__ + "img/icon_user_default.83a65cef.svg";